import { useState } from "react";
import { FalloutCharacter, Quaternion } from "../Data/Response";


interface RotateCharacterModalViewArgs {
    character: FalloutCharacter;
    submitRotateCharacter: (characterId: string, rotation: Quaternion) => void;
}

const RotateCharacterModalView: React.FC<RotateCharacterModalViewArgs> = args => {
    var [x, setX] = useState(0);
    var [y, setY] = useState(0);
    var [z, setZ] = useState(0);
    var [w, setW] = useState(0);

    return <div>
        <h2>Rotate Your Character!</h2>
        <p>Moving {args.character.name}</p>
        <ul>
            <li>
                <input
                    type="number"
                    id="moveCharacterXInput"
                    value={x}
                    onChange={e => {
                        setX(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterXInput">X</label>
            </li>
            <li>
                <input
                    type="number"
                    id="moveCharacterYInput"
                    value={y}
                    onChange={e => {
                        setY(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterYInput">Y</label>
            </li>
            <li>
                <input
                    type="number"
                    id="moveCharacterZInput"
                    value={z}
                    onChange={e => {
                        setZ(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterZInput">Z</label>
            </li>
            <li>
                <input
                    type="number"
                    id="moveCharacterWInput"
                    value={w}
                    onChange={e => {
                        setW(parseInt(e.target.value));
                    }}
                />
                <label htmlFor="moveCharacterWInput">W</label>
            </li>
        </ul>
        <button
            onClick={async e => {
                args.submitRotateCharacter(args.character.id, { X: x, Y: y, Z: z, W: w });
            }}
        >Rotate!</button>
    </div>
}

export default RotateCharacterModalView;